import {
	Button,
	Form,
	Input,
	// Select
} from 'antd'
import {
	useEffect,
	// useMemo,
	useRef,
	useState,
} from 'react'
import api from 'src/api/index.api'
import { AIPromptPreviewModal, ButtonCommon } from 'src/common'
import { useAppDispatch, useAppSelector, usePromptPreview } from 'src/hooks'
import { onCreateDictWordExample } from 'src/redux/definition/definition.actions'
// import { onCreateMeaning } from 'src/redux/definition/definition.actions'
import {
	selectCurrentDictWord,
	selectCurrentDictWordIDFromDef,
} from 'src/redux/definition/definition.selector'
// import { onGetAllDictWordTypes } from 'src/redux/dict/dict.action'
// import { selectDictWordTypes } from 'src/redux/dict/dict.selector'
import { handleSubmitCb, showMessageError, showMessageSuccess } from 'src/utils/function.utils'

const { TextArea } = Input
// const { Option } = Select

export const FormAddExampleItem = () => {
	const dispatch = useAppDispatch()
	const dictWordID = useAppSelector(selectCurrentDictWordIDFromDef)
	const currentDictWord = useAppSelector(selectCurrentDictWord)
	// const dictWordTypes = useAppSelector(selectDictWordTypes)

	const inputRef = useRef()
	const [form] = Form.useForm()
	const [isGeneratingExample, setIsGeneratingExample] = useState(false)
	const [isPreviewingPrompt, setIsPreviewingPrompt] = useState(false)
	const { preview: promptPreview, openPreview, closePreview } =
		usePromptPreview()

	// const wordTypeOptions = useMemo(() => {
	// 	return dictWordTypes?.map(item => {
	// 		return {
	// 			label: item.type,
	// 			value: item.id,
	// 		}
	// 	})
	// }, [dictWordTypes])

	useEffect(() => {
		inputRef.current.focus()
	}, [])

	// useEffect(() => {
	// 	if (!dictWordTypes) {
	// 		dispatch(onGetAllDictWordTypes())
	// 	}
	// }, [dispatch, dictWordTypes])

	const handleSubmit = async () => {
		const values = await form.validateFields()
		// dispatch(
		// 	onCreateMeaning(
		// 		{
		// 			dictWordID,
		// 			...values, // dictWordTypeID, definition
		// 		},
		// 		handleSubmitCb
		// 	)
		// )
		///relace action is onCreateExample
		dispatch(
			onCreateDictWordExample(
				{
					...values, // dictWordTypeID, definition
					wordID: dictWordID,
				},
				handleSubmitCb
			)
		)
	}

	const getExamplePromptContext = () => {
		const word = (currentDictWord?.word || '').trim()
		if (!word) {
			showMessageError('Word is required before generating example')
			return null
		}
		return { word }
	}

	const handleGenerateExampleWithAI = async () => {
		const context = getExamplePromptContext()
		if (!context) return

		try {
			setIsGeneratingExample(true)
			const rs = await api.agentsAdminApi.generateDictionaryExample({
				word: context.word,
				lang: 'vi',
			})
			const example = (rs?.example || '').trim()
			const translate = (rs?.translate || '').trim()
			if (!example || !translate) {
				showMessageError('AI returned incomplete example')
				return
			}
			form.setFieldsValue({
				example,
				translate,
			})
			showMessageSuccess('Generated example successfully')
		} catch (err) {
			showMessageError(
				err?.response?.data || err?.message || 'Failed to generate example'
			)
		} finally {
			setIsGeneratingExample(false)
		}
	}

	const handlePreviewPrompt = async () => {
		const context = getExamplePromptContext()
		if (!context) return

		try {
			setIsPreviewingPrompt(true)
			const rs = await api.agentsAdminApi.previewGenerateDictionaryExamplePrompt({
				word: context.word,
				lang: 'vi',
			})
			openPreview({
				prompt: rs?.prompt || '',
				model: rs?.model || '',
				temperature: rs?.temperature || 0,
				maxOutputTokens: rs?.maxOutputTokens || 0,
			})
		} catch (err) {
			showMessageError(
				err?.response?.data || err?.message || 'Failed to preview prompt'
			)
		} finally {
			setIsPreviewingPrompt(false)
		}
	}

	return (
		<Form form={form}>
			<div className="u-row-right" style={{ marginTop: -8, marginBottom: 8 }}>
				<Button
					size="small"
					type="default"
					style={{ marginRight: 8 }}
					loading={isPreviewingPrompt}
					onClick={handlePreviewPrompt}
				>
					Preview AI prompt
				</Button>
				<Button
					size="small"
					type="default"
					loading={isGeneratingExample}
					onClick={handleGenerateExampleWithAI}
				>
					Generate example with AI
				</Button>
			</div>
			<Form.Item
				label="Example"
				name="example"
				rules={[
					{
						required: true,
						message: 'Please enter example',
					},
				]}
			>
				<TextArea ref={inputRef} placeholder={`Enter example`} />
			</Form.Item>
			<Form.Item
				label="Translate"
				name="translate"
				rules={[
					{
						required: true,
						message: 'Please enter translate',
					},
				]}
			>
				<TextArea ref={inputRef} placeholder={`Enter translate`} />
			</Form.Item>
			<div className="u-row-right">
				<ButtonCommon onClick={handleSubmit} type="primary">
					Save
				</ButtonCommon>
			</div>
			<AIPromptPreviewModal
				visible={promptPreview.visible}
				onCancel={closePreview}
				prompt={promptPreview.prompt}
				model={promptPreview.model}
				temperature={promptPreview.temperature}
				maxOutputTokens={promptPreview.maxOutputTokens}
			/>
		</Form>
	)
}

// FormAddExampleItem
